/**
 * @Author: luoob
 * @Date: 2021-11-09 18:03:04
 * @Last Modified by: luoob
 * @Last Modified time: 2021-11-09 18:03:08
 * @Instruduction: 表单提示语模板文件
 */

/**
 * 表单必填提示语
 * @date 2021-11-09
 * @param {string} str
 * @returns {any}
 */
function getRequiredMsg(str: string) {
    return `请输入${str}`
}

/**
 * 表单限制大小提示
 * @date 2021-11-09
 * @param {string} str
 * @returns {any}
 */
function getSizeMsg(str: string, { min, max } = { min: 0, max: 0 }) {
    if (!min && max) {
        return `${str}不得超过 ${max} 个字`
    } else if (min && !max) {
        return `${str}不得小于 ${min} 个字`
    } else if (min && max) {
        return `请输入正确的${str}, 范围在${min} - ${max}个字`
    } else {
        return str
    }
}

/**
 * 类型错误项
 * @date 2021-11-09
 * @param {string} str
 * @returns {any}
 */
function getTypeMsg(str: string) {
    return `请正确输入${str}`
}

/**
 * 重复提示语
 * @date 2021-11-18
 * @param {string} str
 * @returns {any}
 */
function getExistMsg(str: string) {
    return `该${str}已存在`
}

export {
    getRequiredMsg,
    getSizeMsg,
    getTypeMsg,
    getExistMsg
}
